const globalSettings = ['baseApiUrl', 'maxParallelImageRequests', 'workerClass', 'workerCount', 'workerUrl'];
export default function setGlobals(mapLib, props) {
  for (const key of globalSettings) {
    if (key in props) {
      mapLib[key] = props[key];
    }
  }
  const _props$RTLTextPlugin = props.RTLTextPlugin,
    RTLTextPlugin = _props$RTLTextPlugin === void 0 ? 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js' : _props$RTLTextPlugin;
  if (RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === 'unavailable') {
    mapLib.setRTLTextPlugin(RTLTextPlugin, error => {
      if (error) {
        // eslint-disable-next-line
        console.error(error);
      }
    }, true);
  }
}